"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDefaultValue = function getDefaultValue(_ref) {
  var isMulti = _ref.isMulti,
      primaryValue = _ref.primaryValue,
      otherValue = _ref.otherValue;
  var value = isMulti ? [] : '';

  if (primaryValue !== undefined) {
    value = primaryValue;
  } else if (otherValue !== undefined) {
    value = otherValue;
  }

  if (isMulti && !Array.isArray(value)) {
    return [value];
  }

  return value;
};

var _default = getDefaultValue;
exports.default = _default;